import React from 'react';
import { Helmet } from 'react-helmet';

const MetaTags = ({
  title,
  description,
  image,
  url,
  type = 'website',
  siteName = 'ChillFree TV',
  twitterHandle = '@ChillFreeTV',
}) => {
  // Fallback image if none provided
  const defaultImage = 'https://chillfree.tv/assets/images/chillfree-social-share.jpg';
  const socialImage = image || defaultImage;

  // Ensure absolute URL for image
  const absoluteImageUrl = socialImage.startsWith('http')
    ? socialImage
    : `https://chillfree.tv${socialImage}`;

  // Ensure absolute URL for page
  const absoluteUrl = url?.startsWith('http') ? url : `https://chillfree.tv${url || ''}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={absoluteUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={absoluteUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={twitterHandle} />
      <meta name="twitter:creator" content={twitterHandle} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImageUrl} />

      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />

      {/* Mobile and Responsive */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#0f172a" />

      {/* Favicon and App Icons */}
      <link rel="icon" type="image/x-icon" href="/assets/icons/favicon.ico" />
      <link rel="icon" type="image/png" sizes="16x16" href="/assets/icons/favicon-16x16.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/assets/icons/favicon-32x32.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/assets/icons/apple-touch-icon.png" />

      {/* Web App Manifest */}
      <link rel="manifest" href="/assets/xml/manifest.json" />

      {/* Additional PWA Meta Tags */}
      <meta name="application-name" content="ChillFree TV" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="ChillFree TV" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="msapplication-TileColor" content="#56bdaf" />
      <meta name="msapplication-config" content="/assets/xml/browserconfig.xml" />

      {/* Preconnect for Performance */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
    </Helmet>
  );
};

export default MetaTags;
